import React from "react";
import { Link } from "react-router-dom";

export default function NavButton({ to, icon: Icon, label, isActive, disabled = false }) {
  return (
    <Link
      to={disabled ? "#" : to}
      className={`group flex items-center gap-2 px-3 py-1 rounded-lg transition-all duration-300 transform text-sm
        ${disabled ? "opacity-50 cursor-not-allowed" : "hover:scale-105 hover:shadow-lg"}
        ${isActive && !disabled ? "text-white font-bold" : "text-white"}
      `}
      title={disabled ? "Em breve" : ""}
    >
      <Icon
        className={`transition-transform duration-300 text-sm text-white
          ${!disabled && "group-hover:scale-110"}
        `}
      />
      <span className={`text-white ${isActive ? "font-bold" : "font-medium"} text-sm`}>
        {label}
      </span>
    </Link>
  );
}
